import { ConnectedRouter } from "connected-react-router";
import { Route, Switch } from "react-router-dom";

import history from "../init/history";
import TermsAR from "../pages/Terms/TermsAR";
import TermsEN from "../pages/Terms/TermsEN";
import { AppResource } from "../types/resource.types";
import App from "./App";

const RouterConfig = () => {
  return (
    <ConnectedRouter history={history}>
      <Switch>
        <Route exact path={`/${AppResource.termsAR}`} component={TermsAR} />,
        <Route exact path={`/${AppResource.termsEN}`} component={TermsEN} />,
        <Route>
          <App />
        </Route>
      </Switch>
    </ConnectedRouter>
  );
};

export default RouterConfig;
